import _, { camelCase } from "lodash";
import { Types } from "./accountingIntegrationActions";

const accountingIntegrationReducers = (state, action) => {
	switch (action.type) {
		case Types.ACCOUNTING_INTEGRATION_POLL_ACTION_MODAL: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);

			if (action.poll) {
				newState.integration.accounting[integration].pollActionModal = action.poll;
			} else {
				delete newState.integration.accounting[integration].pollActionModal;
			}

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_UPDATE_PAY_PERIOD: {
			let newState = _.cloneDeep(state);
			const { payPeriods } = newState.integration?.accounting?.[action.integration] || {};

			const period = action.period;

			const updatedPayPeriods = (() => {
				const existingPayPeriod = payPeriods.find((p) => p.payPeriodId === period.payPeriodId);

				if (existingPayPeriod) {
					return payPeriods.map((p) => (p.payPeriodId === period.payPeriodId ? period : p));
				} else {
					return [...payPeriods, period];
				}
			})();

			newState.integration.accounting = {
				...newState.integration?.accounting,
				[action.integration]: {
					...newState.integration?.accounting?.[action.integration],
					payPeriods: updatedPayPeriods,
				},
			};

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_PUSH_POLL_LIST: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);
			const list = newState.integration.accounting[integration].onGoingPolls || [];

			const newPoll = action.poll;
			const existingIndex = list.findIndex((poll) => poll.id == newPoll.id);

			if (existingIndex > -1) {
				// replace the poll at that index
				list[existingIndex] = newPoll;
			} else {
				list.push(newPoll);
			}

			newState.integration.accounting[integration].onGoingPolls = list;

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_SET_POLL_LIST: {
			let newState = _.cloneDeep(state);

			const integration = camelCase(action.integration);

			newState.integration.accounting[integration].onGoingPolls = action.polls;

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_SENDING_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			const sending = newState.integration?.accounting?.[action.integration]?.sendingPayroll;

			let sendingPayroll = [...(Array.isArray(sending) ? sending : [])];

			if (action.status) {
				sendingPayroll.push(action.periodId);
			} else {
				sendingPayroll = sendingPayroll?.filter((item) => item != action.periodId);
			}

			newState.integration.accounting = {
				...newState.integration?.accounting,
				[action.integration]: {
					...newState.integration?.accounting?.[action.integration],
					sendingPayroll,
				},
			};

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_SYNCING_STATUS: {
			let newState = _.cloneDeep(state);

			if (action.unsyncedEmployees) {
				newState.integration.accounting[action.integration].unsyncedEmployees = action.unsyncedEmployees;
			}
			if (action.error) {
				newState.integration.accounting[action.integration].syncError = action.error;
			}
			if (action.syncingStatus) {
				newState.integration.accounting[action.integration].syncingStatus = action.syncingStatus;
			}
			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_UPDATE_FIELD: {
			let newState = _.cloneDeep(state);

			if (!newState.integration.accounting[action.integration].details) {
				newState.integration.accounting[action.integration].details = {};
			} else {
				newState.integration.accounting[action.integration].details = {
					...newState.integration.accounting[action.integration].details,
				};
			}

			newState.integration.accounting[action.integration].details[action.field] = action.value;
			return newState;
		}

		case Types.ACCOUNTING_INTEGRATION_SAVING: {
			let newState = _.cloneDeep(state);

			newState.integration.accounting[action.integration] = {
				...(newState.integration.accounting[action.integration] ?? {}),
				saving: true,
			};

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_SAVE: {
			let newState = _.cloneDeep(state);

			newState.integration.accounting[action.integration] = {
				...(newState.integration.accounting[action.integration] ?? {}),
				...action.data,
				saving: false,
			};

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_ACCOUNTING_STAGE: {
			let newState = _.cloneDeep(state);

			newState.integration.accounting[action.integration].stage = action.stage;

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_COMPANIES: {
			let newState = _.cloneDeep(state);

			newState.integration.accounting[action.integration].companies = action.companies;

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_ACCOUNTS: {
			let newState = _.cloneDeep(state);

			newState.integration.accounting[action.integration].accounts = action.accounts;

			return newState;
		}
		case Types.ACCOUNTING_INTEGRATION_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			const index = newState?.payPeriods?.periods?.map((period) => period.id).indexOf(action.payPeriodId);

			if (action.accountingIntegrationId) {
				if (newState.payPeriods.periods) {
					newState.payPeriods.periods[index].accountingIntegrationId = action.accountingIntegrationId;
				}
				if (
					newState.payroll?.payPeriodDetails?.id == action.payPeriodId &&
					!newState.payroll.payPeriodDetails.accountingIntegrationId
				) {
					newState.payroll.payPeriodDetails.accountingIntegrationId = action.accountingIntegrationId;
				}
			}
			if (action.accountingIntegrationStatus) {
				if (newState.payPeriods.periods) {
					newState.payPeriods.periods[index].accountingIntegrationStatus = action.accountingIntegrationStatus;
				}
				if (newState.payroll?.payPeriodDetails?.id == action.payPeriodId) {
					newState.payroll.payPeriodDetails.accountingIntegrationStatus = action.accountingIntegrationStatus;
				}
			}

			return newState;
		}

		default:
			return state;
	}
};

export default accountingIntegrationReducers;
